import { render, staticRenderFns } from "./TZ3670Component.vue?vue&type=template&id=10a92de4&scoped=true&"
import script from "./TZ3670Component.vue?vue&type=script&lang=js&"
export * from "./TZ3670Component.vue?vue&type=script&lang=js&"
import style0 from "./TZ3670Component.vue?vue&type=style&index=0&id=10a92de4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a92de4",
  null
  
)

export default component.exports